/**
 *
 * Web Push Controller
 *
 * Script that interacts with the Firebase SDK
 */

const $         = require( 'jQuery' );
const _model    = require( './utilities/_model.js' );



var WebPush = function(){

    //if webpush is disbaled then cancel function
    if( ! ITBL.webPush ){
        return;
    }

    //setup some variables
    try{
        this.URLParams      = new URLSearchParams(  (window.location.search).toLowerCase() );
        this.utm_campaign   = this.URLParams.get( 'utm_campaign' ) === 'cross-channel-experience'; // check to make sure we are working with cross-channel param
        this.email          = this.URLParams.get('email'); // get the email
    }catch (e) {
        //URL fallback
        this.utm_campaign   = this.getQueryParams('utm_campaign') === 'cross-channel-experience';
        this.email          = this.getQueryParams('email');

    }

    this.messaging      = null;

    //cache elements
    this.$webPushWrapper    = $(document).find( '.itbl-c-web-push' );
    this.$close             = this.$webPushWrapper.find( '.itbl-c-web-push__close' );
    this.$pushTitle         = this.$webPushWrapper.find( '.itbl-c-web-push__title' );
    this.$pushBody          = this.$webPushWrapper.find( '.itbl-c-web-push__body' );
    this.$icon              = this.$webPushWrapper.find( '.itbl-c-web-push__icon > img' );
    this.$action            = this.$webPushWrapper.find( '.itbl-c-web-push__link' );

    this.pushTimeOut        = 0;

    this.init();

};

WebPush.prototype.init = function(){

    //cancel the execution if we are missing any of these values
    if( ! this.utm_campaign || ! this.email || ! ITBL.webPush ) {
        return;
    }


     //Ask for permission to send request
    this.event__requestPermission();

    this.$close.on( 'click', this.event__closePush.bind(this) );


    this.$action
        .on( 'mouseenter', this.event__iconAnimation.bind(this) )
        .on( 'mouseleave', this.event__triggerTimeOut.bind(this) );

};

WebPush.prototype.getQueryParams = function( name ){
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};


WebPush.prototype.event__requestPermission = function(){

    const config = {
        apiKey: "AIzaSyBhX2rMbhoUzvec5iUuV47RAlNzaCngB1k",
        authDomain: "iterable-cross-channel.firebaseapp.com",
        databaseURL: "https://iterable-cross-channel.firebaseio.com",
        projectId: "iterable-cross-channel",
        storageBucket: "iterable-cross-channel.appspot.com",
        messagingSenderId: "529499794884",
        appId: "1:529499794884:web:e0f93d93b6983b4d"
    };

    //cancel if firebase is not supported
    if( ! firebase.messaging.isSupported() ){
        console.log( 'firebase not supported, most likely because connection is not secure' );
        return;

    }

    //init firebase
    firebase.initializeApp(config);
    this.messaging = firebase.messaging();

    this.messaging.onTokenRefresh(() => {
        this.messaging.getToken().then((refreshedToken) => {
            console.log('Token refreshed.');

            //send the request to WP Admin to send to Iterable
            if( wp_response.response.code === 200 ){
                console.log( 'success', wp_response );

                //set the browser token value in iterable object to true
                _LStorage.extend( 'iterable', {browserToken : true} );
            }else{
                console.log( 'error', wp_response );
            }

        }).catch((err) => {
            console.log('Unable to retrieve refreshed token ', err);
            showToken('Unable to retrieve refreshed token ', err);
        });
    });

    this.messaging.requestPermission()
        .then( ()=> this.messaging.getToken() )
        .then((token)=> {

            console.log( 'success: here is the token', token );

            const setBrowserToken = _LStorage.getValFromStorage( 'iterable', 'browserToken' );

            if( ! setBrowserToken ){
                if( wp_response.response.code === 200 ){
                    console.log( 'success', wp_response );

                    //set the browser token value in iterable object to true
                    _LStorage.extend( 'iterable', {browserToken : true} );
                }else{
                    console.log( 'error', wp_response );
                }
            }else{
                console.log( 'browser token already set in iterable' );
            }

    }).catch(function(err) {
        console.log('Unable to retrieve refreshed token ', err);
    });

    //handle in message
    this.messaging.onMessage( (payload)=>{

        this.view__renderOnMessage( payload );

    } );


};

WebPush.prototype.view__renderOnMessage = function( payload ){

    if(  ! payload.hasOwnProperty( 'notification' )  ){
            return;
    }

    console.log( 'payload: ', payload.notification );
    const title         = payload.notification.title,
        click_action    = payload.notification.click_action,
        icon            = (payload.notification.icon) ? payload.notification.icon : "https://iterable.com/wp-content/uploads/2016/12/Iterable_icon_large.png",
        body            = payload.notification.body;

    const $stickyHeader   = $(document).find('#sticky-nav').outerHeight();
    this.$webPushWrapper
        .css( 'top', `${($stickyHeader + 75)}px` );

    var load = new Promise( (resolve, reject) => {
        //set the custom text for the push
        this.$pushTitle.text( title );
        this.$pushBody.text(body);
        this.$icon.text( icon );
        this.$action.attr('src', click_action );

        resolve();

    } )
        .then( ()=>{

            return this.$webPushWrapper
                .toggleClass( 'transform-active' );



        } );


};

WebPush.prototype.event__closePush = function(event){

    if( typeof  event !== 'undefined'){
        event.preventDefault();
    }

    clearTimeout(this.pushTimeOut);
    this.$webPushWrapper.toggleClass( 'transform-active' );


};

WebPush.prototype.event__iconAnimation = function( event ){

    console.log( 'timeout canceled' );
    clearTimeout(this.pushTimeOut);
    $(this.$icon).itblAnimate( 'animated', 'tada' );

};

WebPush.prototype.event__triggerTimeOut = function(event){

    console.log( 'set timeout started' );

    clearTimeout(this.pushTimeOut);
    this.pushTimeOut = setTimeout(()=>{

        this.$webPushWrapper.toggleClass( 'transform-active' );

    }, 5000);

};


const itblWebPush = new WebPush();

